module.exports = __webpack_public_path__ + "static/media/wallpaper-r1.b28ed7ff.png";